import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, query, where, getDocs, onSnapshot } from 'firebase/firestore';
// eslint-disable-next-line no-unused-vars
import { IoArrowBack, IoPeople, IoSearch, IoChatbubbleEllipses, IoHome } from 'react-icons/io5';
import './ResidentesSearchScreen.css';

import { useAuth } from '../context/AuthContext';
// ... imports

function ResidentesSearchScreen() {
    const navigate = useNavigate();
    const { userData, currentUser } = useAuth();
    const [searchTerm, setSearchTerm] = useState('');
    const [residentes, setResidentes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [allResidents, setAllResidents] = useState([]);
    // ...

    // ...
    // ...
    const [activeChats, setActiveChats] = useState([]); // Residents with active chats

    useEffect(() => {
        if (!userData || !userData.condominioId || !currentUser) return;

        // 1. Load All Residents (Directory)
        const fetchResidents = async () => {
            setLoading(true);
            try {
                const q = query(
                    collection(db, "usuarios"),
                    where("rol", "==", "residente"),
                    where("condominioId", "==", userData.condominioId)
                );
                const snapshot = await getDocs(q);
                const lista = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                // Create a map for quick lookup
                const residentMap = {};
                lista.forEach(r => residentMap[r.id] = r);

                setAllResidents(lista);
                // setResidentes([]); // Directory starts empty
                setLoading(false);

                // 2. Listen to Active Chats
                const qChats = query(
                    collection(db, "chats"),
                    where("participants", "array-contains", currentUser.uid)
                );

                const unsubscribe = onSnapshot(qChats, (snapshot) => {
                    const active = [];
                    snapshot.docs.forEach(doc => {
                        const data = doc.data();
                        const otherId = data.participants.find(p => p !== currentUser.uid);
                        // If we have resident info for this ID, add it
                        if (otherId && residentMap[otherId]) {
                            active.push({
                                ...residentMap[otherId],
                                unreadCount: data[`unread_${currentUser.uid}`] || 0,
                                lastMessageTime: data.lastMessageTime
                            });
                        }
                    });
                    // Sort by unread count desc, then last message
                    const now = new Date();
                    const oneDayMs = 24 * 60 * 60 * 1000;

                    const filteredActive = active.filter(chat => {
                        const isRecent = chat.lastMessageTime && (now - chat.lastMessageTime.toDate() < oneDayMs);
                        return chat.unreadCount > 0 || isRecent;
                    });

                    filteredActive.sort((a, b) => {
                        if (b.unreadCount !== a.unreadCount) return b.unreadCount - a.unreadCount;
                        return (b.lastMessageTime?.seconds || 0) - (a.lastMessageTime?.seconds || 0);
                    });
                    setActiveChats(filteredActive);
                });
                return () => unsubscribe();
            } catch (error) {
                console.error("Error loading data", error);
                setLoading(false);
            }
        };
        fetchResidents();
    }, [userData, currentUser]);

    const handleSearch = () => {
        if (!searchTerm.trim()) {
            setResidentes([]);
            return;
        }

        const term = searchTerm.toLowerCase();
        const filtered = allResidents.filter(r => {
            const nombre = (r.nombre || '').toLowerCase();
            const casa = (r.numeroCasa || '').toLowerCase();
            return nombre.includes(term) || casa.includes(term);
        });
        setResidentes(filtered);
    };

    const handleChat = (residenteId) => {
        navigate(`/chat/${residenteId}`);
    };

    // Privacy: "1 Nombre (sin apellidos)"
    const formatName = (fullName) => {
        if (!fullName) return 'Residente';
        return fullName.split(' ')[0]; // First word only
    };

    return (
        <div className="residentes-search-container">
            {/* Sticky Header */}
            <div className="residentes-fixed-wrapper">
                <div className="residentes-banner-compact">
                    <button onClick={() => navigate('/seguridad')} className="vigilantes-back-btn glass"> {/* Go back to module */}
                        <IoArrowBack size={24} />
                    </button>
                    <div className="residentes-banner-content">
                        <h2>Residentes</h2>
                        <p>Buscador para vigilancia</p>
                    </div>
                    <div className="residentes-banner-icon">
                        <IoSearch />
                    </div>
                </div>

                <div className="search-bar-container">
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Buscar por Nombre o Unidad..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                    />
                    <button className="btn-search" onClick={handleSearch}>
                        <IoSearch />
                    </button>
                </div>
            </div>

            {loading && <p style={{ textAlign: 'center', marginTop: 20 }}>Cargando directorio...</p>}

            {/* Active Chats Section (Only if not searching) */}
            {!searchTerm && activeChats.length > 0 && (
                <div className="active-chats-section">
                    <h3 style={{ padding: '10px 20px', fontSize: '1rem', color: '#4b5563' }}>Mensajes Recientes</h3>
                    <div className="residentes-list">
                        {activeChats.map((r) => (
                            <div key={r.id} className="residente-card" onClick={() => handleChat(r.id)} style={{ borderLeft: r.unreadCount > 0 ? '4px solid #ef4444' : 'none' }}>
                                <div className="residente-icon">
                                    <IoHome size={24} color="#4b5563" />
                                </div>
                                <div className="residente-info">
                                    <h3>{formatName(r.nombre)}</h3>
                                    <p>Unidad: {r.numeroCasa || 'N/A'}</p>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    {r.unreadCount > 0 && (
                                        <div className="notification-badge" style={{
                                            background: '#ef4444', color: 'white', fontSize: '0.75rem', fontWeight: 'bold',
                                            width: '22px', height: '22px', borderRadius: '50%', display: 'flex',
                                            alignItems: 'center', justifyContent: 'center'
                                        }}>
                                            {r.unreadCount}
                                        </div>
                                    )}
                                    <button className="btn-chat-residente">
                                        <IoChatbubbleEllipses />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <hr style={{ margin: '20px', borderTop: '1px solid #e5e7eb' }} />
                </div>
            )}

            {!loading && residentes.length === 0 && searchTerm && (
                <p style={{ textAlign: 'center', marginTop: 20, color: '#6b7280' }}>No se encontraron resultados.</p>
            )}

            <div className="residentes-list">
                {residentes.map((r) => (
                    <div key={r.id} className="residente-card" onClick={() => handleChat(r.id)}>
                        <div className="residente-icon">
                            <IoHome size={24} color="#4b5563" />
                        </div>
                        <div className="residente-info">
                            <h3>{formatName(r.nombre)}</h3>
                            <p>Unidad: {r.numeroCasa || 'N/A'}</p>
                        </div>
                        <button className="btn-chat-residente">
                            <IoChatbubbleEllipses />
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ResidentesSearchScreen;
